(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cabo-plate-product"]) return;
  try {
    
  if (!customElements.get('cabo-plate')) {
    customElements.define('cabo-plate', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return; this.ready = true;
        const tiers = [[1,1990],[2,1490],[6,1190],[10,990],[20,590],[50,450],[100,270],[200,270],[250,240],[300,240],[500,195],[1000,145]];
        const form = this.querySelector('form');
        const quantity = this.querySelector('[data-quantity]');
        const text = this.querySelector('[data-text]');
        const file = this.querySelector('[data-file]');
        const color = this.querySelector('[data-color]');
        const font = this.querySelector('[data-font]');
        const previewText = this.querySelector('[data-preview-text]');
        const logo = this.querySelector('[data-logo]');
        const error = this.querySelector('[data-error]');
        const money = new Intl.NumberFormat('de-DE', {style:'currency',currency:this.dataset.currency || 'EUR'});
        const colors = {'Weiß':'#ffffff','Gelb':'#ffe25b','Rot':'#ff6262','Grün':'#60dc81','Blau':'#82b3ff'};
        const update = () => {
          const q = Number(quantity.value);
          const n = Number.isSafeInteger(q) && q > 0 ? q : 1;
          let tier = tiers[0]; for (const candidate of tiers) if (n >= candidate[0]) tier = candidate;
          this.querySelector('[data-unit]').textContent = money.format(tier[1]/100);
          this.querySelector('[data-total]').textContent = money.format(tier[1]*n/100);
          this.querySelectorAll('[data-tier-row]').forEach(row => { if (Number(row.dataset.tierRow) === tier[0]) row.setAttribute('aria-current','true'); else row.removeAttribute('aria-current'); });
          previewText.textContent = text.value || (file.files.length ? '' : 'DEIN LOGO ODER WUNSCHTEXT');
          previewText.style.color = colors[color.value]; previewText.style.fontFamily = font.value;
          text.setCustomValidity('');
        };
        form.addEventListener('input', update); form.addEventListener('change', update);
        file.addEventListener('change', () => {
          if (this.logoURL) URL.revokeObjectURL(this.logoURL);
          logo.hidden = true; logo.removeAttribute('src');
          const selected = file.files[0];
          if (selected && selected.size > 10*1024*1024) { file.setCustomValidity('Bitte wähle eine Datei bis 10 MB.'); file.reportValidity(); return; }
          file.setCustomValidity('');
          if (selected && (/^image\/(png|jpeg|svg\+xml)$/.test(selected.type))) { this.logoURL = URL.createObjectURL(selected); logo.src = this.logoURL; logo.hidden = false; }
          update();
        });
        form.addEventListener('submit', event => {
          error.hidden = true;
          if (!text.value.trim() && !file.files.length) { event.preventDefault(); text.setCustomValidity('Bitte gib deinen Wunschtext ein oder lade dein Logo hoch.'); text.reportValidity(); }
        });
        update();
      }
      disconnectedCallback() { if(this.logoURL) URL.revokeObjectURL(this.logoURL); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
